<div class="selector-page">
  <div class="selector-header">
    <img src="assets/images/logo-dark.png" alt="Fortune Backoffice">
    <span class="eyebrow">Fortune Backoffice</span>
    <h1>Select your dashboard</h1>
    <p>Choose the operation you want to manage.</p>
  </div>

  <div class="selector-grid">
    <button type="button" class="selector-card fortune" (click)="select('fortune')">
      <span class="selector-icon"><i class="fas fa-route"></i></span>
      <span class="selector-title">Fortune Route</span>
      <span class="selector-copy">Open the main operations and route dashboard.</span>
      <span class="selector-action">Continue <i class="fas fa-arrow-right"></i></span>
    </button>

    <button type="button" class="selector-card lease" (click)="select('fusionLease')">
      <span class="selector-icon"><i class="fas fa-file-contract"></i></span>
      <span class="selector-title">Fusion Lease</span>
      <span class="selector-copy">Open Fusion Lease performance and board statistics.</span>
      <span class="selector-action">Continue <i class="fas fa-arrow-right"></i></span>
    </button>

    <button type="button" class="selector-card sales" (click)="select('boardSales')">
      <span class="selector-icon"><i class="fas fa-cash-register"></i></span>
      <span class="selector-title">Board Sales</span>
      <span class="selector-copy">Open sales-contract performance and board statistics.</span>
      <span class="selector-action">Continue <i class="fas fa-arrow-right"></i></span>
    </button>
  </div>
</div>
